<template>
  <div class="invitation-expired">
    <img
      src="@/assets/illustrations/invitation-expired.png"
    >
    <h4 class="font-weight-bold">
      {{ $tk('ClientPortal.User.InvitationExpired') }}
    </h4>
    <p class="font-weight-light">
      <!-- This invitation is no longer available, please contact account owner. -->
      {{ $tk('ClientPortal.User.InvitationExpiredInfo') }}
    </p>
    <b-link
      to="/"
    >
      {{ $tk('ClientPortal.User.BackToHome') }}
    </b-link>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.invitation-expired {
    height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>
